import { Routes } from '@angular/router';
import { CardAddComponent } from './card-add/card-add.component';
import { SelectCardComponent } from './select-card/select-card.component';
import { PaymentSelectionComponent } from './payment-selection/payment-selection.component';
import { AddCardComponent } from './add-card/add-card.component';
import { ThreedComponent } from './threed/threed.component';
import { SmsComponent } from './sms/sms.component';
import { PinComponent } from './pin/pin.component';
import { OtpComponent } from './otp/otp.component';

export const paymentRoutes: Routes = [
  {
    path: '',
    redirectTo: '/result/page-not-found',
    pathMatch: 'full'
  },
  {
    path: 'create-card/:id',
    component: CardAddComponent
  },
  {
    path: 'select-card/:trackingId',
    component: SelectCardComponent
  },
  {
    path: 'selection/:trackingId',
    component: PaymentSelectionComponent
  },
  {
    path: 'add-card/:trackingId',
    component: AddCardComponent
  },
  {
    path: 'add-card/:sessionId/:trackingId',
    component: AddCardComponent
  },
  {
    path: 'threeD/:trackingId',
    component: ThreedComponent
  },
  {
    path: 'sms/:trackingId',
    component: SmsComponent
  },
  {
    path: 'pin/:trackingId',
    component: PinComponent
  },
  {
    path: 'otp/:trackingId',
    component: OtpComponent
  },
  {
    path: '**',
    redirectTo: '/result/page-not-found',
    pathMatch: 'full'
  }
];
